import React, { useState, useRef, useEffect } from 'react';
import './PinCodeView.css';
import ClaimDetailPublic from '../ClaimDetailPublic';
import { RSKLogo } from '../../components/NavBar';
import {Button, Image} from "@heroui/react";
import {fetchClaimsDetailDataCarrier} from "../../services/carrierService";

function PinCodeView() {
    const [pin, setPin] = useState(['', '', '', '']);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);
    const inputRefs = useRef([]);
    const [loading, setLoading] = useState(false); // Nuevo estado para manejar el estado de carga
    const [sendPin, setSendPin] = useState(null);


    const handleChange = async (index, value) => {
        // Permitir solo letras A-Z y números 0-9, y máximo 1 carácter
        if (/^[A-Za-z0-9]?$/.test(value)) {
            const newPin = [...pin];
            // Convertir a mayúsculas automáticamente
            newPin[index] = value.toUpperCase();
            setPin(newPin);
            setError(false);

            if (value && index < 3) {
                inputRefs.current[index + 1].focus();
            }

            if (newPin.every((digit) => digit !== '')) {
                setLoading(true); // Activar estado de carga
                setErrorMsg(null);

                try {
                    // Llamar al endpoint con el método adecuado
                    const data = await fetchClaimsDetailDataCarrier(newPin.join(''));

                    // Si el servidor devuelve 200, asumimos que está OK (éxito)
                    if (data) {
                        setIsAuthenticated(true); // El usuario está autenticado
                        setSendPin(newPin.join(''));
                    } else {
                        setError(true); // Manejamos el caso donde no hay datos, aunque sea 200
                    }
                } catch (err) {
                    console.error('Error al validar el PIN:', err);

                    // Si el error tiene campo de "response", verificamos el código HTTP
                    if (err.response) {
                        if (err.response.status === 403 || err.response.status === 404) {
                            setError(true); // Mostrar mensaje si es 403 explícito
                            if(err.response.data.error){
                                setErrorMsg(err.response.data.error)
                            }
                        } else {
                            console.error('Error inesperado:', err.response.status);
                        }
                    } else {
                        // Caso donde no hay un "response" en el error (problemas de red o desconexión)
                        console.error('Error de red u otro problema:', err);
                    }
                } finally {
                    setLoading(false); // Desactivar estado de carga en cualquier caso
                }
            }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !pin[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputRefs.current[index - 1].focus();
        } else if (e.key === 'ArrowRight' && index < 3) {
            inputRefs.current[index + 1].focus();
        }
    };

    const resetPin = () => {
        setPin(['', '', '', '']);
        setIsAuthenticated(false);
        setError(false);
        inputRefs.current[0].focus();
    };

    useEffect(() => {
        inputRefs.current[0].focus();
    }, []);

    return (
        <div className="pin-code-wrapper">
            {!isAuthenticated ? (
                <div className="pin-container flex flex-col items-center gap-6">
                    <div className="flex gap-1 justify-center items-center" >
                        <RSKLogo />
                        <Image
                            src= {process.env.PUBLIC_URL + "/PoweredBy.png"}
                            className="max-w-[70px] max-h-[40px] object-contain"
                            width={70}
                            height={40}
                            alt="AWS Logo"
                        />
                    </div>
                    <h1 className="font-serif italic">Only for carrier access</h1>
                    <h2 className="text-2xl font-semibold text-gray-800">
                        Enter your PIN code
                    </h2>
                    <div className="pin-inputs">
                        {pin.map((digit, index) => (
                            <input
                                key={index}
                                ref={(el) => (inputRefs.current[index] = el)}
                                id={`pin-${index}`}
                                type="text"
                                inputMode="text" // Cambiado de numeric a text para permitir letras
                                maxLength="1"
                                value={digit}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                className={`pin-inputs input ${
                                    error ? 'border-red-500 animate-shake' : 'border-gray-300'
                                } focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all`}
                                aria-label={`PIN digit ${index + 1}`}
                                disabled={loading}
                            />
                        ))}
                    </div>
                    {error && (
                        <p className="text-red-500 text-sm">
                            {errorMsg ? errorMsg : "Incorrect PIN. Try again."}
                        </p>
                    )}
                    <Button
                        className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        onPress={resetPin}
                        isLoading={loading}
                    >
                        Reset
                    </Button>
                </div>
            ) : (
                <div className="claim-detail-wrapper">
                    <ClaimDetailPublic code={sendPin}/>
                </div>
            )}
        </div>
    );
}

export default PinCodeView;